import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export const DEFAULT_MILITARY_PAY_TAX_JSON = `{
    "taxYear": 2026,
    "ssWageBase": 184500,
    "federal": {
        "standardDeduction": {
            "single": 16100,
            "mfj": 32200,
            "hoh": 24150
        },
        "brackets": {
            "single": [
                { "rate": 0.10, "upTo": 12400 },
                { "rate": 0.12, "upTo": 50400 },
                { "rate": 0.22, "upTo": 105700 },
                { "rate": 0.24, "upTo": 201775 },
                { "rate": 0.32, "upTo": 256225 },
                { "rate": 0.35, "upTo": 640600 },
                { "rate": 0.37, "upTo": null }
            ],
            "mfj": [
                { "rate": 0.10, "upTo": 24800 },
                { "rate": 0.12, "upTo": 100800 },
                { "rate": 0.22, "upTo": 211400 },
                { "rate": 0.24, "upTo": 403550 },
                { "rate": 0.32, "upTo": 512450 },
                { "rate": 0.35, "upTo": 768700 },
                { "rate": 0.37, "upTo": null }
            ],
            "hoh": [
                { "rate": 0.10, "upTo": 17700 },
                { "rate": 0.12, "upTo": 67450 },
                { "rate": 0.22, "upTo": 105700 },
                { "rate": 0.24, "upTo": 201775 },
                { "rate": 0.32, "upTo": 256200 },
                { "rate": 0.35, "upTo": 640600 },
                { "rate": 0.37, "upTo": null }
            ]
        }
    },
    "states": {
        "AK": { "treatment": "none" },
        "FL": { "treatment": "none" },
        "NV": { "treatment": "none" },
        "NH": { "treatment": "none" },
        "SD": { "treatment": "none" },
        "TN": { "treatment": "none" },
        "TX": { "treatment": "none" },
        "WA": { "treatment": "none" },
        "WY": { "treatment": "none" }
    }
}`;

export class militaryPayTax_template extends vnTemplate {

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["page-content"];
    }

    protected getTemplateName(): string {
        return "militaryPayTax_template";
    }

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="w-form author-setting">
                <div class="form-header">
                    <h3 class="form-title">Military Pay Tax Config</h3>
                    <span data-bind="text: saveStatus" class="milpay-status-text"></span>
                </div>
                <div class="form-body">
                    <p>Edit JSON and Save. Stored as <code>emaki_config:military_pay_tax</code>. Change <code>taxYear</code>, federal brackets, standard deductions, SS wage base, and state treatments for the next tax year.</p>
                    <p>State treatments: <code>none</code> / <code>exempt</code> (tax $0), <code>partial</code> (subtract <code>exemptionCap</code> then apply <code>brackets</code>), <code>taxable</code> (apply <code>brackets</code>). Omitted states are not estimated.</p>
                    <div class="form-group row top">
                        <label for="militaryPayTaxJson" class="form-label">Tax JSON</label>
                        <textarea id="militaryPayTaxJson" class="input-text" rows="28" style="width:100%;min-height:28rem;font-family:monospace;font-size:13px;" data-bind="value: jsonText"></textarea>
                    </div>
                </div>
                <div class="form-footer">
                    <button class="btn" type="button" data-bind="event: { click: onClickValidate }">Validate</button>
                    <button class="btn highlight" type="button" data-bind="event: { click: onClickSave }">Save</button>
                </div>
            </div>
        `;
    }

    protected buildViewModel(): any {
        const self = this;

        return {
            jsonText: ko.observable(DEFAULT_MILITARY_PAY_TAX_JSON),
            saveStatus: ko.observable(""),
            onClickValidate: function () {
                self.onClickValidate();
            },
            onClickSave: function () {
                self.onClickSave();
            }
        };
    }

    public setJson(tax: any): void {
        const vm = this.getTemplateViewModel();
        if (tax && typeof tax === "object" && Object.keys(tax).length > 0) {
            vm.jsonText(JSON.stringify(tax, null, 4));
            return;
        }
        vm.jsonText(DEFAULT_MILITARY_PAY_TAX_JSON);
    }

    public getParsedJson(): object {
        return JSON.parse(this.getTemplateViewModel().jsonText());
    }

    public setSaveStatus(status: string): void {
        this.getTemplateViewModel().saveStatus(status);
    }

    protected onClickValidate(): void {
        try {
            JSON.parse(this.getTemplateViewModel().jsonText());
            this.setSaveStatus("Valid JSON");
        } catch (error) {
            this.setSaveStatus("Invalid JSON: " + (error && error.message ? error.message : "parse failed"));
        }
    }

    protected onClickSave(): void {
        this.caller.save();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/militaryPayTax_template.ts